<template>
  <promoIconButton :isCount="isCount" :leftCounter="leftCounter" :styleCount="styleCount" :type="'freeBets'" />
</template>

<script lang="ts">
import Vue from 'vue';
import { mapGetters } from 'vuex';
import promoIconButton from '@/components/panel/PromoIconButton.vue';
import { IFreeBetSpin } from '@/store/defaultObjects';

export default Vue.extend({
  name: 'PromoIconButtonCount',
  components: {
    promoIconButton
  },
  props: {
    type: String
  },
  data: () => ({}),
  computed: {
    ...mapGetters(['getUiPosition', 'isLandscape', 'getIsMobile', 'getActiveFreeBetSpins']),
    leftCount(): number {
      return this.isLandscape
        ? this.getUiPosition.landscape.panelCount.left
        : this.getUiPosition.portrait.panelCount.left;
    },
    rightCount(): number {
      return this.isLandscape
        ? this.getUiPosition.landscape.panelCount.right
        : this.getUiPosition.portrait.panelCount.right;
    },
    topCount(): number {
      const topLandscapeMobile: number = this.getUiPosition.mobile.landscape.panelCount.top;
      if (this.isLandscape && this.getIsMobile && topLandscapeMobile) {
        return topLandscapeMobile;
      }
      return this.isLandscape
        ? this.getUiPosition.landscape.panelCount.top
        : this.getUiPosition.portrait.panelCount.top;
    },
    scaleCount(): number {
      return this.isLandscape
        ? this.getUiPosition.landscape.panelCount.scale
        : this.getUiPosition.portrait.panelCount.scale;
    },
    isCount(): boolean {
      return this.leftCounter > 0;
    },
    leftCounter(): number {
      return this.getActiveFreeBetSpins.reduce(
        (total: number, item: IFreeBetSpin) => (total += item.reward.betCount),
        0
      );
    },
    styleCount(): any {
      return {
        leftCount: this.leftCount,
        rightCount: this.rightCount,
        topCount: this.topCount,
        scaleCount: this.scaleCount
      };
    }
  },
  methods: {}
});
</script>

<style scoped></style>